import React from 'react'
import styled from 'styled-components'
const Footer = () => {
  return <Wrapper>
             <h5>
              &copy; {new Date().getFullYear()} BenStore | Designed & Developed by <a href="https://ug.linkedin.com/in/benard-awuko-b20591a3" target="_blank" rel="noreferrer">Benard Awuko</a>
              </h5>

  </Wrapper>
}

const Wrapper = styled.footer`
  height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top:0.5rem solid rgb(237, 182, 72);
  background:rgb(138, 12, 126);
  text-align: center;
  span {
    color: var(--clr-primary-5);
  }
  h5 {
    color: var(--clr-white);
    margin: 0.1rem;

    font-weight: 400;
    text-transform: none;
    line-height: 1.25;
    padding:0 0.5rem;
  }
  @media (min-width: 776px) {
    flex-direction: row;
  }

  a{
    text-decoration:none;
    color:yellow;
  }
`

export default Footer
